import React from 'react';
import ModalVideo from 'react-modal-video';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import IconButton from '../buttons/IconButton';

function VideoModal({ video, closeAction }) {
  return (
    video && (
      <div className="tour-player">
        <ModalVideo channel="custom" url={video} onClose={closeAction} isOpen autoplay />
        <div className="close" data-testid="tour-overview-video-close-button">
          <IconButton className="px-3" onClick={closeAction}>
            <FontAwesomeIcon className="text-one f-std-bold" icon={faTimes} />
          </IconButton>
        </div>
      </div>
    )
  );
}

export default VideoModal;
